import { useState } from "react";
import { useAuth } from "./AuthContext";
import { formatApiError } from "./api";
import { ArrowUpRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A192F] via-[#0F2342] to-[#16335A] px-6"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="font-serif leading-tight text-white">
            <div className="text-2xl">Escapafy</div>
            <div className="italic text-[#E8C97A] text-sm tracking-[0.18em] uppercase">
              Admin
            </div>
          </div>
          <p className="mt-6 text-white/70 font-serif italic">
            Tú diriges el negocio.{" "}
            <span className="text-[#E8C97A]">Nosotros organizamos el viaje.</span>
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white/5 backdrop-blur-md border border-[#E8C97A]/20 p-8 lg:p-10 space-y-5"
          style={{ borderRadius: "2px" }}
        >
          <h1 className="font-display text-3xl text-white">Iniciar sesión</h1>

          <label className="block">
            <span className="block text-xs font-medium text-[#E8C97A] mb-2 uppercase tracking-wider">
              Email
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              data-testid="login-email"
              className="w-full px-4 py-3 bg-white/5 border border-white/20 focus:border-[#E8C97A] focus:outline-none focus:ring-2 focus:ring-[#E8C97A]/30 text-white text-sm placeholder-white/40"
              style={{ borderRadius: "2px" }}
            />
          </label>

          <label className="block">
            <span className="block text-xs font-medium text-[#E8C97A] mb-2 uppercase tracking-wider">
              Contraseña
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="w-full px-4 py-3 bg-white/5 border border-white/20 focus:border-[#E8C97A] focus:outline-none focus:ring-2 focus:ring-[#E8C97A]/30 text-white text-sm"
              style={{ borderRadius: "2px" }}
            />
          </label>

          {error && (
            <p
              data-testid="login-error"
              className="text-red-100 bg-red-900/40 border border-red-400/40 px-4 py-3 text-sm"
            >
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-[#E8C97A] hover:bg-[#D4B35E] disabled:opacity-60 text-[#16335A] px-6 py-3.5 rounded-full text-sm font-semibold inline-flex items-center justify-center gap-2 transition-colors"
          >
            {loading ? "Entrando..." : "Entrar"}
            <ArrowUpRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
